// b2c列表
export default [
    {
        path: "errorderList",
        name: "errorderList",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/errorder/list/index"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "allErrorderList",
        name: "allErrorderList",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/errorder/alllErrorLst/index"),
        // meta: {
        //     bread: false,
        // }
    },
    // b2c订单编辑查看
     {
         path: "errorderList/upadte/:type",
         name: "errorderUpdate",
         component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/errorder/update/index"),
         meta: {
             bread: false,
         }
     },
    //-----------------------------订单管理端-------------------------------------------
    // b2c订单编辑查看
    {
        path: "orderAdminList",
        name: "orderAdminList",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/b2corder/admin/list/index"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "orderAdminList/upadte/:type",
        name: "orderAdminUpdate",
        component: () => import(/* webpackChunkName: "b2corder" */ "@/views/boss/b2corder/admin/update/index"),
        meta: {
            bread: false,
        }
    },
]
